import { Action } from 'redux';
import { IPaginationMetaResponse, IPaginationParams } from '../../libs/quickjobs-api';
import { IJob } from '../types/job';

export const JOBS_FETCH_REQUEST = 'JOBS_FETCH_REQUEST';
export const JOBS_FETCH_SUCCESS = 'JOBS_FETCH_SUCCESS';
export const JOB_DETAIL_FETCH_REQUEST = 'JOB_DETAIL_FETCH_REQUEST';
export const JOB_DETAIL_FETCH_SUCCESS = 'JOB_DETAIL_FETCH_SUCCESS';
export const JOBS_ERROR = 'JOBS_ERROR';
export const JOB_BAN_REQUEST = 'JOBS_BAN_REQUEST';
export const JOB_BAN_SUCCESS = 'JOBS_BAN_SUCCESS';
export const JOB_CANCEL_REQUEST = 'JOBS_CANCEL_REQUEST';
export const JOB_CANCEL_SUCCESS = 'JOBS_CANCEL_SUCCESS';

export interface IJobsFetchRequestAction extends Action {
  type: typeof JOBS_FETCH_REQUEST;
  payload: {
    search?: string;
  } & IPaginationParams;
}

export interface IJobsFetchSuccessAction extends Action {
  type: typeof JOBS_FETCH_SUCCESS;
  payload: { jobs: IJob[]; meta: IPaginationMetaResponse };
}

export interface IJobDetailFetchRequestAction extends Action {
  type: typeof JOB_DETAIL_FETCH_REQUEST;
  payload: { id: number };
}

export interface IJobDetailFetchSuccessAction extends Action {
  type: typeof JOB_DETAIL_FETCH_SUCCESS;
  payload: { job: IJob };
}

export interface IJobsErrorAction extends Action {
  type: typeof JOBS_ERROR;
  message: string;
}

export interface IJobBanRequestAction extends Action {
  type: typeof JOB_BAN_REQUEST;
  payload: {
    id: number;
  };
}

export interface IJobBanSuccessAction extends Action {
  type: typeof JOB_BAN_SUCCESS;
  payload: {
    id: number;
  };
}

export interface IJobCancelRequestAction extends Action {
  type: typeof JOB_CANCEL_REQUEST;
  payload: {
    id: number;
  };
}

export interface IJobCancelSuccessAction extends Action {
  type: typeof JOB_CANCEL_SUCCESS;
  payload: {
    job: IJob;
  };
}

export type IJobsAction =
  | IJobsFetchSuccessAction
  | IJobDetailFetchSuccessAction
  | IJobsErrorAction
  | IJobBanSuccessAction
  | IJobCancelSuccessAction;

export function fetchJobsRequest(
  params?: { search?: string } & IPaginationParams
): IJobsFetchRequestAction {
  return {
    type: JOBS_FETCH_REQUEST,
    payload: {
      ...params,
    },
  };
}

export function fetchJobsSuccess(
  jobs: IJob[],
  meta: IPaginationMetaResponse
): IJobsFetchSuccessAction {
  return {
    type: JOBS_FETCH_SUCCESS,
    payload: {
      jobs,
      meta,
    },
  };
}

export function fetchJobDetailRequest(id: number): IJobDetailFetchRequestAction {
  return {
    type: JOB_DETAIL_FETCH_REQUEST,
    payload: { id: id },
  };
}

export function fetchJobDetailSuccess(job: IJob): IJobDetailFetchSuccessAction {
  return {
    type: JOB_DETAIL_FETCH_SUCCESS,
    payload: {
      job,
    },
  };
}

export function banJobRequest(jobId: number): IJobBanRequestAction {
  return {
    type: JOB_BAN_REQUEST,
    payload: {
      id: jobId,
    },
  };
}

export function banJobSuccess(jobId: number): IJobBanSuccessAction {
  return {
    type: JOB_BAN_SUCCESS,
    payload: {
      id: jobId,
    },
  };
}

export function cancelJobRequest(jobId: number): IJobCancelRequestAction {
  return {
    type: JOB_CANCEL_REQUEST,
    payload: {
      id: jobId,
    },
  };
}

export function cancelJobSuccess(job: IJob): IJobCancelSuccessAction {
  return {
    type: JOB_CANCEL_SUCCESS,
    payload: {
      job: job,
    },
  };
}

export function jobsError(message: string): IJobsErrorAction {
  return {
    type: JOBS_ERROR,
    message,
  };
}



// WEBPACK FOOTER //
// ./src/store/actions/jobs.ts